export const GET_TENSILE_TEST_REQUEST = "GET_TENSILE_TEST_REQUEST";
export const GET_TENSILE_TEST_SUCCESS = "GET_TENSILE_TEST_SUCCESS";
export const GET_TENSILE_TEST_FAILURE = "GET_TENSILE_TEST_FAILURE";

export const DELETE_TENSILE_TEST_REQUEST = "DELETE_TENSILE_TEST_REQUEST";
export const DELETE_TENSILE_TEST_SUCCESS = "DELETE_TENSILE_TEST_SUCCESS";
export const DELETE_TENSILE_TEST_FAILURE = "DELETE_TENSILE_TEST_FAILURE";

export const CREATE_TENSILE_TEST_REQUEST = "CREATE_TENSILE_TEST_REQUEST";
export const CREATE_TENSILE_TEST_SUCCESS = "CREATE_TENSILE_TEST_SUCCESS";
export const CREATE_TENSILE_TEST_FAILURE = "CREATE_TENSILE_TEST_FAILURE";

export const EDIT_TENSILE_TEST_REQUEST = "EDIT_TENSILE_TEST_REQUEST";
export const EDIT_TENSILE_TEST_SUCCESS = "EDIT_TENSILE_TEST_SUCCESS";
export const EDIT_TENSILE_TEST_FAILURE = "EDIT_TENSILE_TEST_FAILURE";


